import {
  FileText,
  CalendarDays,
  Handshake,
  Mic,
  Megaphone,
  FolderKanban,
  Users,
  UserCheck,
  Briefcase,
  Rocket,
  Star,
  PlusCircle,
} from "lucide-react";

// Every link the admin sidebar has always had — same names, same paths.
// Only the grouping and the icons are new.
const NAV_GROUPS = [
  {
    label: "Requests",
    items: [
      { path: "/admin/ProjectRequests", name: "Project Requests", icon: FolderKanban },
      { path: "/admin/BlogRequests", name: "Blog Requests", icon: FileText },
      { path: "/admin/EventRequests", name: "Event Requests", icon: CalendarDays },
      { path: "/admin/ambassadors", name: "Ambassadors Requests", icon: Star },
      { path: "/admin/investors", name: "Investors Requests", icon: Briefcase },
      { path: "/admin/founders", name: "Founders Requests", icon: Rocket },
    ],
  },
  {
    label: "Create",
    items: [
      { path: "/admin/AddProject", name: "Add Project", icon: PlusCircle },
      { path: "/admin/AddBlog", name: "Add Blog", icon: PlusCircle },
      { path: "/admin/AddEvent", name: "Add Event", icon: PlusCircle },
      { path: "/admin/AddPartner", name: "Add Partner", icon: PlusCircle },
      { path: "/admin/AddPodcast", name: "Add Podcast", icon: PlusCircle },
      { path: "/admin/AddAnnouncement", name: "Add Announcement", icon: Megaphone },
    ],
  },
  {
    label: "Manage",
    items: [
      { path: "/admin/ManagePartners", name: "Manage Partners", icon: Handshake },
      { path: "/admin/ManagePodcasts", name: "Manage Podcasts", icon: Mic },
      { path: "/admin/ManageProjects", name: "Manage Projects", icon: FolderKanban },
      { path: "/admin/ManageEvents", name: "Manage Events", icon: CalendarDays },
      { path: "/admin/ManageBlogs", name: "Manage Blogs", icon: FileText },
    ],
  },
  {
    label: "People",
    items: [
      { path: "/admin/users", name: "Users", icon: Users },
      { path: "/admin/amb/verified", name: "Verified Ambassadors", icon: UserCheck },
      { path: "/admin/investors/verified", name: "Verified Investors", icon: UserCheck },
      { path: "/admin/founders/verified", name: "Verified Founders", icon: UserCheck },
    ],
  },
];

export default NAV_GROUPS;
